/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fork } from 'redux-saga/effects';
import ActionConstants from '../constants/';
import { takeLatestUntilApiCancel } from './merchantListing';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* fetchPaymentModeWatcher(): Generator<any, void, unknown> {
  yield fork(takeLatestUntilApiCancel, ActionConstants.FETCH_PAYMENT_MODES);
}
